import MenuButton from '../MenuButton.jsx'
import useMenuItemExportBizReq from './useMenuItemExportBizReq.jsx'
import useMenuItemExportDevReq1 from './useMenuItemExportDevReq1.jsx'
import useMenuItemExportDevReq2 from './useMenuItemExportDevReq2.jsx'

export default function MenuButtonExportDoc(props) {
    const items = [
        useMenuItemExportBizReq(),
        useMenuItemExportDevReq1(),
        useMenuItemExportDevReq2(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            导出文档
        </MenuButton>
    )
}
